
import { Component, OnInit, Inject, ViewChild } from "@angular/core"
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog"
import { ToastrService } from "ngx-toastr"
import { LexTranslateService } from "src/app/core/services/lex-translate.service"
import { String } from "lodash"
import { SubjectTableComponent } from "@app/modules/subject/subjects-management/subject-table/subject-table.component"
import { SubjectService } from "@app/cadastro/admin/services/subject.service"
import { SubjectSetService } from "@app/cadastro/admin/services/subject-set.service"
import { DeleteActions } from "@app/shared/enum/delete-actions"


@Component({
  selector: "seb-modal-subject-delete",
  templateUrl: "./modal-subject-delete.component.html",
  styleUrls: ["./modal-subject-delete.component.css"],
})
export class ModalSubjectDeleteComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ModalSubjectDeleteComponent>,
    private subjectService: SubjectService,
    private subjectSetService: SubjectSetService,
    private toastr: ToastrService,
    public lextranslate: LexTranslateService,
    @Inject(MAT_DIALOG_DATA) public subject: any
  ) {}

  @ViewChild(SubjectTableComponent)
  table: SubjectTableComponent

  iconAlert: string = "/assets/img/alert-triangle.svg"
  modalQuestion: string
  cancelLabel: string
  confirmLabel: string
  textDelete: string
  textDeleteSubject: string = ""
  subjectDeleteId: string = ""
  actionType: number

  async ngOnInit() {

    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    this.modalQuestion = this.lextranslate.i18n["ba7dd5f5-b8c1-4c4f-96a4-45b05663d293"]
    this.modalQuestion.toLocaleUpperCase();
    this.cancelLabel = this.lextranslate.i18n["f2929717-3d73-4a39-8280-d41f768d092b"]
    this.confirmLabel = this.lextranslate.i18n["a6fbd8eb-1255-4665-9421-5c818dd4fc27"]
    this.textDelete = this.subject.messageDelete +" "+ "$subject ?"
    this.actionType =  this.subject.actionType
    this.textDeleteSubject = this.textDelete.replace(
       "$subject",
       this.subject.data.name
    )
    this.subjectDeleteId = this.subject.data.id
  }

  onDelete() {

    if (this.actionType === DeleteActions.deleteSubjectSet) {
      this.subjectSetService.delete(this.subjectDeleteId).subscribe({
        next: () => {
          this.toastr.success(``, this.lextranslate.i18n["d81898d6-bcbf-4811-9033-0cd2b7bb23f9"]+"!")
          this.closeDialog(true)
        },
        error: (err) => {
          if (err.error || err._body) {
            const errorMsg = err.error || JSON.parse(err._body)
            this.toastr.error(``, `${errorMsg.message}`)
          }
        },
      })
    }

    if (this.actionType === DeleteActions.deleteSubject) {
      this.subjectService.delete(this.subjectDeleteId).subscribe({
        next: () => {
          this.toastr.success(``, this.lextranslate.i18n["2d4ca4bf-a789-409c-b5f9-ed4b5443738e"]+"!")
          this.closeDialog(true)
        },
        error: (err) => {
          if (err.error || err._body) {
            const errorMsg = err.error || JSON.parse(err._body)
            this.toastr.error(``, `${errorMsg.message}`)
          }
        },
      })
    }
  }

  closeDialog(refresh: boolean = false) {
    this.dialogRef.close(refresh)
  }
}
